import React, { useEffect, useState, useContext } from 'react';
import { useHistory } from "react-router-dom";
import toastError from "../../errors/toastError";
import api from "../../services/api";

import Avatar from "@material-ui/core/Avatar";
import { makeStyles } from "@material-ui/core/styles";

import { AuthContext } from "../../context/Auth/AuthContext";

import { isNil } from 'lodash';
import ShowTicketOpen from '../ShowTicketOpenModal';
import { existingTicketFromError, canOpenExistingTicket } from '../../utils/existingTicket';

// Cartão de contato dentro da bolha, no padrão do WhatsApp Web: herda a cor do texto da
// bolha (recebida ou enviada, claro ou escuro) e separa a ação por um filete fino.
const useStyles = makeStyles((theme) => {
    const isDark = theme.palette.type === "dark";
    return {
        card: {
            minWidth: 240,
            maxWidth: 320,
            margin: "0 0 4px -3px",
            color: "inherit",
            whiteSpace: "normal",
        },
        head: {
            display: "flex",
            alignItems: "center",
            gap: 12,
            padding: "6px 6px 10px",
        },
        avatar: {
            width: 46,
            height: 46,
            flex: "none",
        },
        name: {
            flex: 1,
            minWidth: 0,
            fontSize: 15,
            fontWeight: 500,
            lineHeight: "20px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
        },
        action: {
            display: "block",
            width: "100%",
            margin: 0,
            padding: "9px 8px",
            border: 0,
            borderTop: `1px solid ${isDark ? "rgba(233,237,239,0.14)" : "rgba(11,20,26,0.1)"}`,
            background: "transparent",
            color: isDark ? "#53bdeb" : "#027eb5",
            font: "inherit",
            fontSize: 14,
            fontWeight: 500,
            textAlign: "center",
            cursor: "pointer",
            borderRadius: "0 0 6px 6px",
            "&:hover": {
                backgroundColor: isDark ? "rgba(255,255,255,0.05)" : "rgba(11,20,26,0.04)",
            },
            "&:focus-visible": {
                outline: `2px solid ${isDark ? "#53bdeb" : "#027eb5"}`,
                outlineOffset: -2,
            },
            "&:disabled": {
                opacity: 0.5,
                cursor: "default",
                backgroundColor: "transparent",
            },
        },
    };
});

const VcardPreview = ({ contact, numbers, queueId, whatsappId, channel }) => {
    const classes = useStyles();
    const history = useHistory();
    const { user } = useContext(AuthContext);

    const companyId = user.companyId;

    const [openAlert, setOpenAlert] = useState(false);
    const [userTicketOpen, setUserTicketOpen] = useState("");
    const [queueTicketOpen, setQueueTicketOpen] = useState("");

    const [selectedContact, setContact] = useState({
        id: 0,
        name: "",
        number: 0,
        profilePicUrl: ""
    });

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            const fetchContacts = async () => {
                try {
                    if (isNil(numbers)) {
                        return
                    }
                    const number = numbers.replace(/\D/g, "");
                    const getData = await api.get(`/contacts/profile/${number}`, { params: { channel: channel } });

                    if (getData.data.contactId && getData.data.contactId !== 0) {
                        let obj = {
                            id: getData.data.contactId,
                            name: contact,
                            number: numbers,
                            urlPicture: getData.data.urlPicture || getData.data.profilePicUrl
                        }

                        setContact(obj)
                    } else {
                        let contactObj = {
                            name: contact,
                            number: number,
                            email: "",
                            companyId: companyId
                        }

                        const { data } = await api.post("/contacts", contactObj);
                        setContact(data)
                    }

                } catch (err) {
                    // Cartão de contato cujo número não está no WhatsApp (ERR_CHECK_NUMBER):
                    // mostra o cartão com o número, sem toast a cada abertura do ticket.
                    const code = err?.response?.data?.error;
                    if (err?.response?.status === 404 || code === "ERR_CHECK_NUMBER" || code === "ERR_INVALID_NUMBER") {
                        setContact({ id: 0, name: contact, number: numbers, profilePicUrl: "" });
                        return;
                    }
                    console.log(err)
                    toastError(err);
                }
            };
            fetchContacts();
        }, 500);
        return () => clearTimeout(delayDebounceFn);
    }, [companyId, contact, numbers]);

    const handleCloseAlert = () => {
        setOpenAlert(false);
        setOpenAlert(false);
        setUserTicketOpen("");
        setQueueTicketOpen("");
    };

    const handleNewChat = async () => {
        try {
            const { data: ticket } = await api.post("/tickets", {
                contactId: selectedContact.id,
                userId: user.id,
                status: "open",
                queueId,
                companyId: companyId,
                whatsappId
            });

            history.push(`/tickets/${ticket.uuid}`);
        } catch (err) {
            const ticket = existingTicketFromError(err);
            if (!ticket) {
                toastError(err);
                return;
            }

            if (canOpenExistingTicket(ticket, user?.id)) {
                setOpenAlert(false);
                setUserTicketOpen("");
                setQueueTicketOpen("");
                history.push(`/tickets/${ticket.uuid}`);
            } else {
                setOpenAlert(true);
                setUserTicketOpen(ticket?.user?.name);
                setQueueTicketOpen(ticket?.queue?.name);
            }
        }
    }

    return (
        <div className={classes.card}>
            <ShowTicketOpen
                isOpen={openAlert}
                handleClose={handleCloseAlert}
                user={userTicketOpen}
                queue={queueTicketOpen}
            />
            <div className={classes.head}>
                <Avatar
                    className={classes.avatar}
                    src={selectedContact?.urlPicture || undefined}
                    alt=""
                />
                <span className={classes.name}>{selectedContact.name}</span>
            </div>
            <button
                type="button"
                className={classes.action}
                onClick={handleNewChat}
                disabled={!selectedContact.id}
            >
                Conversar
            </button>
        </div>
    );

};

export default VcardPreview;
